export const getSelectedElementId = ({ isSelected, listId }) =>
	isSelected ? `listbox-${listId}-selected` : null;
